
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { AuthHttp } from '../../admin/services/token.service';
// import { AppConstant } from './../../shared/constant/app.constant';
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};
@Injectable()
export class CompanyService {
    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }

    getAllCompanies() {
        return this.http.get(`setups/company`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
 getAllLoginCompany() {
        return this.http.get(`setups/get-login-company`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLoginCompanySetup() {
        return this.http.get(`setups/get-login-company-setup`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    getAllLanguages() {
        return this.http.get(`setups/languages`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllNatureOfBusiness() {
        return this.http.get(`setups/nature-of-business`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    save(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setups/company`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    update(companyId, bodyObj) {

        return this.http.put(`setups/company/${companyId}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    getAllCompanyDirectors() {
        return this.http.get(`setups/company-director`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCompanyDirectorsByCompanyId() {
        return this.http.get(`setups/company-director-by-companyId`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCustomerCompanyDirectorsByCompanyId(companyId) {
        return this.http.get(`setups/company-director-by-companyId?companyId=${companyId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    appUpdateCompanyDirector(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setups/company-director`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    deleteCompanyDirector(companyDirectoeId) {
        return this.http.delete(`setups/company-director?companyDirectorId=${companyDirectoeId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
}